import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { GallectionCentaurCard } from '../../../CentaurCard';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { StreamType } from '../../../Stream';
import s from '../../AddToGroupsPanel.scss';
var FolderList = function (_a) {
    var submissionType = _a.submissionType, headerContent = _a.headerContent, folders = _a.folders, isFetching = _a.isFetching, streamId = _a.streamId, onFolderSelected = _a.onFolderSelected;
    var t = useTranslation().t;
    var anyFolderIsActive = folders.some(function (_a) {
        var suggested = _a.suggested, added = _a.added, loading = _a.loading;
        return suggested || added || loading;
    });
    var hasNoFolders = !isFetching && !folders.length;
    return (React.createElement(React.Fragment, null,
        headerContent,
        React.createElement(StreamedList, { streamId: streamId, streamType: StreamType.WITH_OFFSET, className: classnames(s['list'], s['tabs-list']), bottomedClassName: s['bottomed'] },
            folders.map(function (_a) {
                var folder = _a.folder, saving = _a.loading, added = _a.added, suggested = _a.suggested;
                return (React.createElement("button", { key: folder.folderId, className: s['card'], onClick: anyFolderIsActive
                        ? undefined
                        : function () { return onFolderSelected(folder.folderId); } },
                    React.createElement(GallectionCentaurCard, { gallection: folder, mode: saving ? 'progress' : added || suggested ? 'done' : 'default' })));
            }),
            hasNoFolders && (React.createElement("span", { className: s['no-folders'] }, t("addToGroup.noFolders." + submissionType)))),
        isFetching && React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })));
};
FolderList.displayName = 'FolderList';
export default FolderList;
//# sourceMappingURL=FolderList.js.map